export const SDK_VERSION = '7.64.0';
